import React from 'react';
import {Outlet, useParams} from 'react-router-dom';
import {Box} from '@mui/material';
import CampaignTabs from '@/views/campaigns/components/campaign-tabs';
import useCampaignIndexRedirect from '@/views/campaigns/hooks/use-campaign-index-redirect';
import useCampaignTabs from '@/views/campaigns/hooks/use-campaign-tabs';
import useFilterCampaignTabsForFifaRevamp from '@/views/campaigns/hooks/use-filter-campaign-tabs-for-fifa-revamp';
import CampaignsViewSwitcher from '@/components/campaigns-view-switcher';
import useCampaignQuery from '@/hooks/queries/use-campaign-query';
import styles from './Campaign.module.scss';

function Campaign() {
  const {campaignId} = useParams<{campaignId: string}>();
  const {campaign, isLoading} = useCampaignQuery({
    campaignId,
    fetchBrandActionItems: true,
  });

  useCampaignIndexRedirect({
    campaign,
    campaignId: campaignId || '',
    isLoading: isLoading || false,
  });

  const {tabs} = useCampaignTabs(campaign);
  const {filteredTabs} = useFilterCampaignTabsForFifaRevamp({tabs});

  if (!campaign.loaded) {
    return null;
  }

  return (
    <Box className={styles.container}>
      <CampaignTabs tabs={filteredTabs} rightSlot={<CampaignsViewSwitcher />} />
      <Box className={styles.body}>
        <Outlet />
      </Box>
    </Box>
  );
}

export default Campaign;
